import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';
import {
  desktop_breakpoint,
  desktop_breakpoint_extended,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

const PostPageStyles = styled.div`
  padding-top: 32px;

  .post-container {
    margin: 0 auto;
    max-width: 86%;

    .post-title {
      font-family: 'acumin-pro', Helvetica, Arial, sans-serif;
      color: ${Colors.primary.black.standard};
      font-style: normal;
      font-weight: 600;
      font-size: 18px;
      letter-spacing: normal;
      line-height: normal;
      padding-top: 4px;
    }
    .post-category {
      font-family: 'acumin-pro-semi-condensed', Helvetica, Arial, sans-serif;
      color: #71777e;
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      letter-spacing: normal;
      line-height: 15px;
      text-decoration: none;
    }
    img {
      max-width: 100%;
      height: auto;
    }
  }
  .post-header {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 12px 0 24px 0;
  }
  .post-authors {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 20px;

    .post-author-info {
      font-family: 'source-sans-pro', Helvetica, Arial, sans-serif;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left: 15px;
    }
    .post-author-image {
      border-radius: 50px;
      height: 50px;
      width: 50px;
    }
  }
  a.post-author:link,
  a.post-author:visited,
  a.post-author:hover,
  a.post-author:active {
    align-items: center;
    display: flex;
    flex-direction: row;
    text-decoration: none;

    .intro {
      color: ${Colors.primary.black.standard};
      font-family: 'source-sans-pro', Helvetica, Arial, sans-serif;
      font-size: 18px;
      font-weight: 400;
    }
    .caption {
      color: ${Colors.accent.grey1.standard};
      font-family: 'source-sans-pro', Helvetica, Arial, sans-serif;
      font-size: 14px;
      font-weight: 400;
      :empty {
        min-height: 21px;
      }
    }
  }
  .post-article-image {
    margin-bottom: 40px;
    position: relative;
    height: 57.4vw;
  }
  .post-copy-brief {
    margin-bottom: 20px;
  }
  .related-posts {
    border-top: 1px solid ${Colors.primary.black.tint};
    padding-top: 20px;

    h3 {
      padding: 10px 0;
      text-align: center;
      font-size: 18px;
      font-weight: 600;
    }
  }
  .post-actions {
    z-index: 3;
    align-items: center;
    background-color: ${Colors.primary.white.standard};
    border-top: 1px solid ${Colors.primary.black.tint};
    bottom: 0;
    display: flex;
    flex-direction: row;
    left: 0;
    justify-content: center;
    padding: 10px 0%;
    position: fixed;
    width: 100%;

    svg {
      path {
        fill: #24292d;
      }
    }

    .subscribe-svg {
      padding-right: 30px;
    }
    .favorite-svg {
      padding-right: 20px;
    }
    .favorite-svg.favorited {
      position: relative;
      left: -3px;
      top: -1px;

      svg {
        height: 20px;
        width: 20px;
        path {
          fill: #ffc50a;
        }
      }
    }
    svg {
      cursor: pointer;
      height: 25px;
      width: 25px;
    }
  }

  @media only screen and (min-width: ${desktop_breakpoint}px) {
    padding-top: 64px;
    .post-container {
      .post-title {
        font-weight: 700;
        font-size: 32px;
        letter-spacing: -0.35px;
        line-height: 38px;
      }
      .post-category {
        font-weight: 700;
        font-size: 12px;
        letter-spacing: normal;
      }
    }
    .post-authors {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 30px;
    }
    .post-header {
      padding: 22px 0 34px 0;
    }
    .related-posts {
      padding-top: 20px;
      h3 {
        padding: 20px 0 17px 0;
        text-align: center;
        font-size: 32px;
        font-weight: 700;
        line-height: 38px;
        letter-spacing: -0.35px;
      }
    }
  }

  @media only screen and (min-width: ${desktop_breakpoint_extended}px) {
    .post-container {
      max-width: 800px;
    }
    .post-actions {
      border-top: 0;
      justify-content: flex-end;
      padding: 0;
      padding-top: 25px;
      position: static;
      width: auto;

      svg {
        height: 20px;
        width: 20px;
      }
    }
    .post-article-image {
      height: 52.2vw;
      max-height: 534px;
    }
    .related-posts-list {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(250px, calc(33% - 20px)));
      grid-gap: 20px;
      justify-content: center;
    }
  }
`;

export default PostPageStyles;
